/* import __COLOCATED_TEMPLATE__ from './company-profile-about.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { makeMoney } from 'sh-www/helpers/make-money';

const BRANDS_CLASS_NAME = 'company-profile-seller-view__sidebar__brands';
const EARNINGS_CLASS_NAME = 'company-profile-seller-view__sidebar__connection-details';
const CONTACTS_CLASS_NAME = 'company-profile-seller-view__sidebar__contacts';

export default class CompanyProfileAbout extends Component {
  @service session;
  @service router;

  get brandsClassName() {
    return BRANDS_CLASS_NAME;
  }

  get earningsClassName() {
    return EARNINGS_CLASS_NAME;
  }

  get contactsClassName() {
    return CONTACTS_CLASS_NAME;
  }

  get earningsYearToDate() {
    const earnings = this.args.currentCompanyConnection?.ytdEarningsInCents;
    if (earnings == null) return "-";
    return makeMoney([(earnings / 100).toFixed(2)]);
  }

  get earningsAllTime() {
    const earnings = this.args.currentCompanyConnection?.lifetimeEarningsInCents;
    if (earnings == null) return "-";
    return makeMoney([(earnings / 100).toFixed(2)]);
  }
}
